import { render, staticRenderFns } from "./SectionView.vue?vue&type=template&id=68d309d7&"
import script from "./SectionView.vue?vue&type=script&lang=js&"
export * from "./SectionView.vue?vue&type=script&lang=js&"
import style0 from "./SectionView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports